/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function UserFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="user-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M16.408 9.667C16.401 9.811 16.401 9.955 16.387 10.099C16.344 10.53 16.238 10.954 16.072 11.354C15.684 12.29 14.972 13.076 14.078 13.554C13.696 13.758 13.284 13.906 12.86 13.99C12.577 14.046 12.289 14.075 12 14.075C11.856 14.075 11.712 14.06 11.568 14.053C11.425 14.032 11.281 14.018 11.14 13.99C10.857 13.934 10.58 13.85 10.313 13.739C9.646 13.463 9.051 13.021 8.593 12.463C8.226 12.017 7.949 11.499 7.782 10.946C7.656 10.532 7.592 10.1 7.592 9.667C7.592 9.522 7.606 9.379 7.613 9.235C7.634 9.092 7.649 8.948 7.677 8.807C7.733 8.524 7.817 8.247 7.928 7.98C8.204 7.313 8.645 6.717 9.204 6.259C9.65 5.893 10.168 5.616 10.72 5.449C10.997 5.365 11.281 5.308 11.568 5.28C11.711 5.266 11.856 5.266 12 5.259C12.144 5.266 12.289 5.266 12.432 5.28C12.863 5.322 13.287 5.429 13.687 5.594C14.22 5.815 14.709 6.142 15.117 6.55C15.628 7.06 16.009 7.696 16.218 8.387C16.302 8.663 16.358 8.947 16.387 9.235C16.401 9.378 16.401 9.523 16.408 9.667Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <circle cx={12} cy={9.667} r={4.408} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 20.499C6.204 20.165 6.247 20.075 6.482 19.761C6.923 19.173 7.459 18.655 8.062 18.235C8.666 17.815 9.337 17.493 10.042 17.284C11.456 16.865 12.992 16.914 14.377 17.423C14.929 17.626 15.455 17.899 15.938 18.235C16.541 18.655 17.077 19.173 17.518 19.761C17.753 20.075 17.796 20.165 18 20.499L6 20.499Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M6 20.499A6.893 6.893 0 0 1 18 20.499" data-tinysvg-shape="arc" data-tinysvg-arc="12 23.893 6.893 6.893 209.496 330.504 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M6 20.499L18 20.499" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
